import moment from 'moment';
import { useMutation } from 'react-query';
import { useAppContext } from '../../appProvider/contextProvider';
import getAmount from '../../Util/getAmount';
import { deleteSubscription  } from '../../services/stripe';
import { viewPrivacyPolicy, viewTermsAndCondition } from '../../Util/TermsAndPrivacy';
import { cancelShopifySubscription } from '../../services/shopifySubscription';



const CancelPlan = () => {

    const {
       setCancelPlanPopupOpen,
       planDetails,
       refetchProfile,
       isFetching,
       refetchFeatures,
       setCancelPlanSuccess,
       setCancelPlanFailure,
       isShopify,
    } = useAppContext();

    const getFormattedDate = (date) => {
        return moment(date).format('MMM DD, YYYY')
    }

    const cancelPlan = useMutation(() => {
        return deleteSubscription()
    }, {
        onSuccess: (data) =>{
            if(data.errors) {
                setCancelPlanFailure(true);
            } else {
                refetchProfile();
                refetchFeatures();
                setCancelPlanSuccess(true);
            }
            setCancelPlanPopupOpen(false);
        }
    });

    const cancelShopifyPlan = useMutation(() => {
        return cancelShopifySubscription()
    }, {
        onSuccess: (data) => {
            if(data.errors) {
                setCancelPlanFailure(true);
            } else {
                refetchProfile();
                refetchFeatures();
                setCancelPlanSuccess(true);
            }
            setCancelPlanPopupOpen(false);
        }
    });

    const cancel = (event) => {
        event.preventDefault();
        if(isShopify) {
            cancelShopifyPlan.mutate();
        } else {
            cancelPlan.mutate();
        }
    }

    const isSubscriptionBased = planDetails?.subscription_type === 'subscriber-based';

    return !isFetching && <>
        <div className="modal fade show" tabindex="-1">
            <div className="modal-dialog ">
                <div className="modal-content">
                    <div className="modal-body p-5">
                        <h3 className="mb-5">Cancel your plan</h3>
                        <p className="text-uppercase my-3">Current plan</p>
                        <hr/>
                        <h5 className="mt-4"> 
                            { 
                                            isSubscriptionBased
                                            ? 'Subscribers'
                                            : 'Impressions'
                            } 
                            based
                        </h5>
                        <h5 className="mb-3 regular">${getAmount(planDetails?.amount)} per {planDetails?.interval}</h5>
                        <p className="my-4">Your plan will be cancelled, but still available until the end of your billing period on {getFormattedDate(planDetails?.current_period_end)}
                        </p>
                        <p>If you change your mind, you can renew your subscription.</p>
                        <button className="btn btn-block btn-danger mt-5 mb-2" onClick={cancel} >Cancel Plan</button>
                        <button className="btn btn-block btn-outline mb-3" onClick={() => setCancelPlanPopupOpen(false)} >Go back</button>
                        <p><small>By cancelling your plan , you agree to ChirpyWeb's <b onClick={viewTermsAndCondition} className="terms-link">Terms of Service</b> and <b onClick={viewPrivacyPolicy} className="terms-link">Privacy Policy</b>.</small></p>
                    </div>
                </div>
            </div>
        </div>
        <div className="modal-backdrop fade show"></div>
    </>
}

export default CancelPlan;